import React, { useState } from "react";
import "./FaucetFormComponent.scss";

const BACKEND_URL = "https://pds-dase-portal-api.fly.dev";

async function handleCypress(setMessage, props, transactionData) {
  const response = await fetch(`${BACKEND_URL}/${props.user.sub}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(transactionData)
  });
  if (!response.ok) {
    setMessage("1");
  } else {
    setMessage(`${props.funding}:${props.serverId}`);
  }
}

function FaucetFormComponent(props) {
  const [blockchainId, setBlockchainId] = useState("");
  const [message, setMessage] = useState("");

  const handleChange = (event) => {
    setBlockchainId(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const selfInfo = {
      id: "0xb85973a890991e1d3cc2f5925302a532a9d17b71",
      credentials:
        "0xdfbe3f4ce2c85e26a6fa9b0481c7c3ddfb8ca15e502a3d67422a5d67d5e0a89a",
    };
    
    let data;
    let route;
    if (props.funding && props.funding === "credit") {
      data = {
        funderId: selfInfo.id,
        funderCredentials: selfInfo.credentials,
        userToFundId: blockchainId,
        termSheetTemplate: "fundingTerms",
        terms: {
          totalLeos: 60000000,
          leosPerTx: 20000000,
          ttl: 31563000,
        },
      };
      route = "create";
    } else {
      data = {
        senderCurrency: "SILVER",
        receiverCurrency: "SILVER",
        senderId: selfInfo.id,
        senderCredentials: selfInfo.credentials,
        receiverId: blockchainId,
        currencyAmount: 500000,
      };
      route = "transfer";
    }
    const transactionData = {
      funding: props.funding.toUpperCase(),
      testNet: props.serverId.toUpperCase(),
    };
    try {
      // For cypress testing
      if (window.Cypress) {
        await handleCypress(setMessage, props, transactionData);
        return;
      } 
      // Posts the transaction-to-be-made to the db-client backend
      const transactionResponse = await fetch(`${BACKEND_URL}/${props.user.sub}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(transactionData)
      });
      // Will return 400 if the user has at least 3 posts within the last 24 hours for debit, 10 for credit, per network
      if (!transactionResponse.ok) {
        const errPayload = await transactionResponse.json();
        const { timeToWait } = errPayload;
        setMessage(`Error: ${transactionResponse.status} ${transactionResponse.statusText}...Please wait ${(((timeToWait / 1000) / 60) / 60).toFixed(2)} hours before making another ${props.funding} transaction from ${props.serverId}`);
        throw new Error("Bad Response ", transactionResponse.statusText);
    }
      const apiResponse = await fetch(`${props.endpoint}/${route}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });
      if (!apiResponse.ok) {
        setMessage(`Error: ${apiResponse.status} ${apiResponse.statusText}`);
        return;
      }
      setMessage(`Funds transferred (500k Leos)`);
    } catch (error) {
      console.error("ERROR", error);
      return;
    }
  };

  return (
    <>
      <h1>{props.title}</h1>
      <div>
        <input
          type="text"
          className="input"
          name="blockchainId"
          placeholder="Blockchain ID"
          value={blockchainId}
          onChange={handleChange}
        />
        <button
          className="button is-primary" 
          data-cy="button-fund"
          onClick={handleSubmit}
        >
          {props.buttonText}
        </button>
      </div>
      <p data-cy="form-message">{message}</p>
    </>
  );
}

export default FaucetFormComponent;
